import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SortInfo } from '../../../overviews/generic-overview/components/display-settings-bar/entities/sort-info.entity';
import { PaginatedResults } from '../../../overviews/generic-overview/components/pagination/entities/paginated-results.entity';
import { PaginationInfo } from '../../../overviews/generic-overview/components/pagination/entities/pagination-info.entity';
import { ApiQuery } from '../../api/entities/api-query.entity';
import { FragmentId, RecordId } from '../entities/metadata/metadata.entity';
import { PartialRecord } from '../entities/partial-record.class';

export interface RecordSearchOptions {
    annotate?: boolean;
    includeDeleted?: boolean;
    retry?: boolean;
    fields?: string[];
    trackConsult?: boolean;
}

@Injectable({ providedIn: 'root' })
export abstract class ShRecordService {
    abstract getRecord(recordId: string, options?: RecordSearchOptions): Observable<PartialRecord>;
    abstract getRecords(
        paginationInfo: PaginationInfo,
        sortInfo: SortInfo,
        query: ApiQuery
    ): Observable<PaginatedResults<PartialRecord>>;
    abstract getAllRecords(query: ApiQuery): Observable<PartialRecord[]>;
    abstract registerConsultation(fragmentId: FragmentId | RecordId): void;
}
